import { useAuth as useClerkAuth } from '@clerk/clerk-react';

export const clerkPublishableKey =
  process.env.REACT_APP_CLERK_PUBLISHABLE_KEY ||
  process.env.NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY || '';

const allowClerkInDev =
  process.env.REACT_APP_ENABLE_CLERK_IN_DEV === 'true' ||
  process.env.NEXT_PUBLIC_ENABLE_CLERK_IN_DEV === 'true';

const isLocalhost = 
  typeof window !== 'undefined' && 
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

const isLiveKey = clerkPublishableKey.startsWith('pk_live_');

// Enable Clerk when a key is present in production, or explicitly allowed in dev,
// but disable it if we are running locally with production live keys to prevent auth errors.
export const isClerkEnabled =
  Boolean(clerkPublishableKey) &&
  (process.env.NODE_ENV === 'production' || allowClerkInDev) &&
  !(isLocalhost && isLiveKey);

const stableAuthDisabled = {
  isLoaded: true,
  isSignedIn: false,
  getToken: () => Promise.resolve(null),
};

// Custom hook that safely exposes Clerk auth state. When Clerk is disabled
// (e.g., in development), it returns no-op defaults so the app can run.
function useAuthDisabled() {
  return stableAuthDisabled;
}

function useAuthEnabled() {
  return useClerkAuth();
}

export const useAuthCompat = isClerkEnabled ? useAuthEnabled : useAuthDisabled;
